var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{ref:_vm.fieldData.model,attrs:{"label":_vm.fieldData.label,"required":_vm.fieldData.required,"items":_vm.fieldData.items},model:{value:(_vm.proxyValue),callback:function ($$v) {_vm.proxyValue=$$v},expression:"proxyValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }